import React from 'react';

import './Profile.css';

import Spinner from '../compUtils/Spinner';

import { useDispatch } from 'react-redux'
import { useObjectSelector, getObject , useNestedObjectSelector, getNestedObject} from '../redux/hooks'

import { Link } from "react-router-dom";


function Profile(props) {
    const dispatch = useDispatch()
    const objectId = "/api/profiles/" + props.profileId
    const profileSelector = useObjectSelector(objectId)
    const profile = getObject(objectId, profileSelector, dispatch)
    const thumbnailSelector = useNestedObjectSelector(objectId, (profile)=>"/api/images/"+profile.thumbnail)
    const thumbnail = getNestedObject(profile,()=>"/api/images/"+profile().thumbnail, thumbnailSelector, dispatch)

    return (
        <div class="box tile">

            <div class="columns is-mobile">

                <div class="column is-narrow">
                    <figure class="image is-128x128">
                        {thumbnail() !== "UNKNOWN" ?
                            <Link to={"/profiles/" + props.profileId}>
                                <img class="is-rounded" src={thumbnail().source} alt={thumbnail().name} />
                            </Link>
                            :
                            <Spinner />
                        }

                    </figure>
                </div>

                <div class="column ">
                    <div class="block is-size-2">
                        {profile() !== "UNKNOWN" ?
                            profile().name
                            :
                            <Spinner />}
                    </div>
                    <div class="block">
                        <div>
                            {profile() !== "UNKNOWN" ?
                                profile().reviews.length + " "
                                :
                                <Spinner />}
                            critiques
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Profile;